import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { InterceptorModule } from './interceptors/interceptor.module';
import { NgxsStoreModule } from '../ngxs/ngxs.module';
import { NotLinkedToAccountWindowModule } from './components/not-linked-to-account-window/not-linked-to-account-window.module';
import { ChunkLoadErrorHandler } from './error-handlers/chunk-load-error.handler';

@NgModule({ imports: [BrowserModule,
        BrowserAnimationsModule,
        IonicModule.forRoot(),
        InterceptorModule,
        NgxsStoreModule,
        NotLinkedToAccountWindowModule], providers: [
        DatePipe,
        {
            provide: RouteReuseStrategy,
            useClass: IonicRouteStrategy,
        },
        {
            provide: ErrorHandler,
            useClass: ChunkLoadErrorHandler,
        },
        provideHttpClient(withInterceptorsFromDi(), withJsonpSupport()),
    ] })
export class CoreModule {
}
